import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import MSLALogo from 'components/MSLALogo';
import './index.css';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '0',
    paddingTop: (props) => (props.loading ? '10vh' : '0.25rem'),
    width: '100%',
    minHeight: '30vh',
    // borderTop: '1px solid #e0e0e0',
    borderBottom: '1px solid #e0e0e0',
    textAlign: 'center',
  },
  content: {
    padding: '2rem',
  },
  noRecordsMessage: {},
  backdrop: {
    position: 'absolute',
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
  },
}));

const ReportContent = ({ children, loading = false, hasData = false }) => {
  const classes = useStyles({ loading });
  return (
    <div className={classes.root}>
      {loading ? (
        <>
          Loading...
          <Backdrop open={loading} className={classes.backdrop}>
            <MSLALogo className="loadingAnimation" height="200" />
          </Backdrop>
        </>
      ) : hasData ? (
        <div className={classes.content}>{children}</div>
      ) : (
        <div className={classes.noRecordsMessage}>
          No data to display. Please expand your search criteria and try again.
        </div>
      )}
    </div>
  );
};

export default ReportContent;
